<form [formGroup]="timeForm"
  class="time-picker">
  <div class="time-inputs">
    <input type="text"
      (input)="formatTime($event)"
      formControlName="time"
      placeholder="HH:MM" />
  </div>

  <div class="am-pm-toggle">
    <label class="d-flex">
      <input type="radio"
        formControlName="period"
        value="AM" /> <span>AM</span>
    </label>
    <label class="d-flex ps-4">
      <input type="radio"
        formControlName="period"
        value="PM" /> <span>PM</span>
    </label>
  </div>
</form>
<div class="errors"
  *ngIf="timeForm.invalid && timeForm.touched">
  <div class="help-block with-error lib-validation-error"
    *ngIf="timeForm.get('time')?.errors?.['required']"><span class="icon icon-attention alert-icon"></span>
    <ul class="list-unstyled alert-messages error-msgs">
      <li>Field is required.</li>
    </ul>
  </div>
  <div class="help-block with-error lib-validation-error"
    *ngIf="timeForm.get('time')?.errors?.['pattern']"><span class="icon icon-attention alert-icon"></span>
    <ul class="list-unstyled alert-messages error-msgs">
      <li>Invalid Time</li>
      <!-- Enter time in HH:MM format (1-12, 00-59). -->
    </ul>
  </div>
  <div class="help-block with-error lib-validation-error"
    *ngIf="timeForm.get('period')?.errors?.['required']"><span class="icon icon-attention alert-icon"></span>
    <ul class="list-unstyled alert-messages error-msgs">
      <li>Select AM or PM.</li>
    </ul>
  </div>
</div>